import React from "react";
import { Form } from "react-bootstrap";

const CategoryFilter = ({ categories, filterCategory, setFilterCategory }) => {
  return (
    <Form.Select className="me-2" value={filterCategory} onChange={(e) => setFilterCategory(e.target.value)}>
      <option value="All">All Categories</option>
      {categories.map((cat, index) => (
        <option key={index} value={cat}>
          {cat}
        </option>
      ))}
    </Form.Select>
  );
};

export default CategoryFilter;
